// extracted by mini-css-extract-plugin
module.exports = {"div":"layout-module--div--11EK8","body":"layout-module--body--20bke"};